import CustomCreatives from "./CustomCreatives";

const AdgridCustomCreatives = () => {
    return (
        <CustomCreatives mode="creative" />
    )
}

export default AdgridCustomCreatives